const locales = {
  searchResultCount: {
    fr: (n: number) => {
      if (n === 0) {
        return <>Nous n'avons trouvé aucun chantier.</>
      } else if (n === 1) {
        return <>Nous avons trouvé un chantier.</>
      } else return null
    },
    de: (n: number) => {
      if (n === 0) {
        return <>Wir haben keine Einrichtung gefunden.</>
      } else if (n === 1) {
        return <>Wir haben eine Einrichtung gefunden.</>
      } else return <>Wir haben {n} Einrichtungen gefunden.</>
    },
  },
  searchPlaceholder: {
    fr: 'Chercher un chantier',
    de: 'Suchen Sie ein Restaurant',
  },
  buttonFilters: {
    fr: 'Filtres',
    de: 'Filter',
  },
  buttonApplyFilters: {
    fr: 'Appliquer les filtres',
    de: 'Filter anwenden',
  },
  buttonResetFilters: {
    fr: 'Tout effacer',
    de: 'Filter zurücksetzen',
  },
  foodTypeTitle: {
    fr: 'Type de chantier',
    de: 'Küche',
  },
  restaurantTypeTitle: {
    fr: 'Type de chantier',
    de: 'Restauranttyp',
  },
  mapButtonLocateMe: {
    fr: 'Me situer',
    de: 'Meine Position',
  },
  mapButtonCloseby: {
    fr: 'À proximité',
    de: 'In der Nähe',
  },
  mapButtonList: {
    fr: 'Liste',
    de: 'Liste',
  },
  mapButtonMap: {
    fr: 'Carte',
    de: 'Karte',
  },
  mapButtonEnterNavigationMode: {
    fr: 'Naviguer dans la carte',
    de: 'Navigieren Sie auf der Karte',
  },
  mapButtonEnterNavigationModeShort: {
    fr: 'Naviguer',
    de: 'Navigieren',
  },
  mapButtonExitNavigationMode: {
    fr: 'Quitter la navigation',
    de: 'Verlassen Sie die Navigation',
  },
  mapButtonExitNavigationModeShort: {
    fr: 'Quitter',
    de: 'Verlassen',
  },
  buttonSeeMore: {
    fr: 'Voir davantage de chantiers',
    de: 'Mehr Restaurants anzeigen',
  },
  filtersTitle: {
    fr: 'Filtrer les chantiers',
    de: 'Filtern Sie die Restaurants',
  },
  filtersPrice: {
    fr: 'Prix',
    de: 'Preis',
  },
  openToday: {
    fr: 'Ouvert aujourd’hui',
    de: 'Heute geöffnet',
  },
  openNote: {
    fr: 'Les horaires, fournis à titre indicatif, sont actualisés chaque mois.',
    de: 'Die Öffnungszeiten werden monatlich aktualisiert.',
  },
  loadingError: {
    fr: "Une erreur s'est produite. Veuillez réessayer plus tard.",
    de: 'Beim Laden der Daten ist ein Fehler aufgetreten.',
  },
  readerUpdate: {
    fr: 'Signaler une erreur',
    de: 'Eine Aktualisierung vorschlagen',
  },
  unableToLoc: {
    fr: 'Impossible de vous situer. Peut-être que la géolocalisation est désactivée dans cette application ou indisponible sur votre appareil.',
    de: 'Es ist nicht möglich, Ihren Standort zu bestimmen. Vielleicht ist die Geolokalisierung in dieser Anwendung deaktiviert oder auf Ihrem Gerät nicht verfügbar.',
  },
  continueReading: {
    fr: 'Continuer la lecture',
    de: 'Weiterlesen',
  },
  infoAddress: {
    fr: 'Adresse',
    de: 'Adresse',
  },
  infoSchedules: {
    fr: 'Horaires',
    de: 'Stundenpläne',
  },
  infoSchedulesNote: {
    fr: 'Ces heures d’ouverture sont fournies à titre indicatif.',
    de: 'Diese Öffnungszeiten sind als Richtwerte zu verstehen.',
  },
  publishedOn: {
    fr: 'Publié le',
    de: 'Publiziert:',
  },
}

export default locales
